<template functional>
  <div v-if="props.type == 'product-item'" class="placeholder__container">
    <div
      class="placeholder__image"
      :style="`--aspect-ratio:${props.ratio}`"></div>
    <p class="placeholder__text first"></p>
    <p class="placeholder__text"></p>
  </div>
  <div
    v-else
    class="placeholder__container"
    :style="`--aspect-ratio:${props.ratio}`">
    <div class="placeholder__random"></div>
  </div>
</template>

<script>
export default {
  name: 'PlaceholderItem',
  props: ['type', 'ratio'],
};
</script>
